"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stageLabelTranslator = exports.propertyLabelTranslatorWithIsHubSpotDefined = exports.propertyLabelTranslator = exports.propertyDescriptionTranslator = exports.tryYourTranslation = exports.tryLookup = exports.makeDescriptionKey = exports.makeNameSpacedKey = exports.convertToKey = exports.isInvalidString = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _getDescriptionHashKey = _interopRequireDefault(require("./internal/getDescriptionHashKey"));

var _isValidI18nKey = _interopRequireDefault(require("I18n/utils/isValidI18nKey"));

var re = /[\()\/\.\:\?\,\s\-\–\'&]/gi;
var nameSpaceKey = 'recordProperties';
var descriptionsNameSpaceKey = nameSpaceKey + ".propertyDescriptions";

var silentI18nText = function silentI18nText(key) {
  var temp = _I18n.default.lookup(key);

  var translation = temp && typeof temp !== 'function' && _I18n.default.text(key);

  return translation || undefined;
};

var tryLookup = function tryLookup(key, aString) {
  return silentI18nText(key) || aString;
};

exports.tryLookup = tryLookup;

var isInvalidString = function isInvalidString(maybeString) {
  return typeof maybeString !== 'string' || maybeString.length === 0;
};

exports.isInvalidString = isInvalidString;

var convertToKey = function convertToKey(aString) {
  return isInvalidString(aString) ? '' : aString.replace(re, '_').toLowerCase();
};

exports.convertToKey = convertToKey;

var makeNameSpacedKey = function makeNameSpacedKey(aString) {
  return nameSpaceKey + "." + convertToKey(aString);
};

exports.makeNameSpacedKey = makeNameSpacedKey;

var makeDescriptionKey = function makeDescriptionKey(label, description) {
  return descriptionsNameSpaceKey + "." + (0, _getDescriptionHashKey.default)(description);
};

exports.makeDescriptionKey = makeDescriptionKey;

var tryYourTranslation = function tryYourTranslation(aString, optionalKeyPrefix) {
  var keyString = convertToKey(aString);

  if (!isInvalidString(optionalKeyPrefix)) {
    keyString = optionalKeyPrefix + "." + keyString;
  }

  return tryLookup(keyString, aString);
};

exports.tryYourTranslation = tryYourTranslation;

var propertyLabelTranslator = function propertyLabelTranslator(label) {
  var nameSpaceLookupKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : nameSpaceKey;

  if (label && label === label.toUpperCase()) {
    return label;
  }

  return tryYourTranslation(label, nameSpaceLookupKey);
};

exports.propertyLabelTranslator = propertyLabelTranslator;

var propertyLabelTranslatorWithIsHubSpotDefined = function propertyLabelTranslatorWithIsHubSpotDefined(_ref) {
  var label = _ref.label,
      nameSpaceLookupKey = _ref.nameSpaceLookupKey,
      isHubSpotDefined = _ref.isHubSpotDefined;

  if (isHubSpotDefined !== undefined && !isHubSpotDefined) {
    return label;
  }

  return propertyLabelTranslator(label, nameSpaceLookupKey || nameSpaceKey);
};

exports.propertyLabelTranslatorWithIsHubSpotDefined = propertyLabelTranslatorWithIsHubSpotDefined;

var propertyDescriptionTranslator = function propertyDescriptionTranslator(label, description) {
  if (isInvalidString(description) || typeof _I18n.default.lookup(descriptionsNameSpaceKey) !== 'object') {
    return description;
  }

  var descriptionKey = makeDescriptionKey(label, description);
  return tryLookup(descriptionKey, description);
};

exports.propertyDescriptionTranslator = propertyDescriptionTranslator;
var dealHubspotStages = {
  //deal stages - BE file here: https://git.hubteam.com/HubSpot/Deals/blob/master/DealsBase/src/main/java/com/hubspot/deals/base/DealsPipeline.java
  appointmentscheduled: 'appointment scheduled',
  qualifiedtobuy: 'qualified to buy',
  presentationscheduled: 'presentation scheduled',
  decisionmakerboughtin: 'decision maker bought-in',
  contractsent: 'contract sent',
  closedwon: 'closed won',
  closedlost: 'closed lost'
}; //pipeline stages - BE file here: https://git.hubteam.com/HubSpot/ObjectPipelines/blob/master/PipelinesCore/src/main/java/com/hubspot/objectpipelines/DefaultImmutablePipelines.java

var ticketHubspotStages = {
  '1': 'new',
  '2': 'waiting on contact',
  '3': 'waiting on us',
  '4': 'closed'
};
/**
 * Translates a stage on the default deal or ticket pipeline
 * @param {Object} stage - needs stage.label, stage.id, and stage.pipelineId
 */

var stageLabelTranslator = function stageLabelTranslator(stage) {
  var defaultPipeline = stage.pipelineId === 'default' || stage.pipelineId === '0';

  if (!defaultPipeline) {
    return stage.label;
  }

  var stageObjectType = stage.objectType;
  var defaultStageName = stageObjectType === 'DEAL' ? dealHubspotStages[stage.stageId] : ticketHubspotStages[stage.stageId];
  var stageIdMatchesName = stage.label.toLowerCase() === defaultStageName;

  if (stageIdMatchesName && (0, _isValidI18nKey.default)("stageLabels." + stage.stageId)) {
    return _I18n.default.text("stageLabels." + stage.stageId);
  }

  return stage.label;
};

exports.stageLabelTranslator = stageLabelTranslator;